<template>
    <div>
        <v-layout row wrap class="otherProductionToggleArea" v-if="showToggles" >
            <v-flex xs6>
                <v-switch
                        style="background-color: rgba(0,0,0,0);"
                    :label="`${ $t('site.common.cultureBoostMinimum')}: ${ isUseMinCultureBoost ? $t('site.common.yes'): $t('site.common.no')}`"
                    v-model="isUseMinCultureBoost"
                ></v-switch>
            </v-flex>
            <v-flex xs6>
                <v-switch
                        style="background-color: rgba(0,0,0,0);"
                        :label="`${ $t('site.common.collectionsPerDay')}: ${ isUseCollectionsPerDay ? $t('site.common.yes'): $t('site.common.no')}`"
                        v-model="isUseCollectionsPerDay"
                ></v-switch>
            </v-flex>
        </v-layout>

        <v-data-table
                :headers="headers"
                :items="membersComputed"
                hide-actions
                class="elevation-1"
        >
            <template slot="headerCell" slot-scope="props">
                <v-tooltip top max-width="400">
                    <span slot="activator">
                        <span v-if="props.header.icon && !props.header.subtitle"><img style="display:inline;" :src="`/static/img/icons/${props.header.icon}.png`"></span>
                        <span v-else-if="props.header.icon" class="header-icon-container" :style="`background-image: URL('/static/img/icons/${props.header.icon}.png');`">
                            <center><span class="header-icon-caption">{{props.header.subtitle}}</span></center>
                        </span>
                        <span v-else>
                        {{ props.header.text }}
                        </span>
                    </span>
                    <span v-html="props.header.tooltip || props.header.text"></span>
                </v-tooltip>
            </template>

            <template slot="items" slot-scope="props">
                <td v-if="members && members.length > 1"><elv-avatar-icon :avatar="props.item.avatar" :isFriend="props.item.isFriend" width="32"/></td>
                <td v-if="members && members.length > 1"><router-link :to="'/player/'+ props.item.server + '/' + props.item.playerId">{{ props.item.username }}</router-link></td>
                <td><span :title="`${props.item.cityReport.cultureBoostPercent}`"><img :src="`/static/img/icons/culture_boost_${props.item.cityReport.cultureBoostPercent}.png`"></span></td>
                <td><vue-numeric :value="props.item.cityReport.production.moneyComputed"/></td>
                <td><vue-numeric :value="props.item.cityReport.production.moneyUsedComputed"/></td>
                <td><vue-numeric :value="props.item.cityReport.production.moneyRemainingComputed" v-bind:class="{ negativeValue: props.item.cityReport.production.moneyRemainingComputed < 0, positiveValue: props.item.cityReport.production.moneyRemainingComputed > 0}"/></td>
                <td><vue-numeric :value="props.item.cityReport.production.suppliesComputed"/></td>
                <td><vue-numeric :value="props.item.cityReport.production.suppliesUsedComputed"/></td>
                <td><vue-numeric :value="props.item.cityReport.production.suppliesRemainingComputed" v-bind:class="{ negativeValue: props.item.cityReport.production.suppliesRemainingComputed < 0, positiveValue: props.item.cityReport.production.suppliesRemainingComputed > 0}"/></td>
                <td><vue-numeric :value="props.item.cityReport.production.mana"/></td>
            </template>
            <template slot="no-data">
                <v-alert :value="true" color="error" icon="warning">
                    Sorry, nothing to display here :(
                </v-alert>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import VueNumeric from 'vue-numeric';
    import ElvAvatarIcon from "./ElvAvatarIcon"
    let elvenStats = require('../lib/elven-stats');
    export default {
        name: "elv-other-production-table",
        props: { members: {required:true}, showToggles: {required: false, default: false} },
        components: {
            ElvAvatarIcon,
            VueNumeric},
        data() {
            return {
                isUseMinCultureBoost: true,
                isUseCollectionsPerDay: true,
            }
        },
        computed: {
            membersComputed: {
                get: function() {
                    let self = this;
                    let computed = _.map(this.members, function(m) {
                        try {

                            if (m && m.cityReport && m.cityReport.production) {
                                let production = _.get(m, "cityReport.production");
                                let cultureBoost = elvenStats.computeCultureBoostPercentForUser(m); // todo change to discrete

                                production.cultureBoostPercentMin = (cultureBoost * 100);
                                production.moneyComputed = production.money || 0;

                                production.suppliesComputed = production.supplies || 0;

                                if (self.isUseMinCultureBoost) {
                                    production.moneyComputed *= cultureBoost;
                                    production.suppliesComputed *= cultureBoost;
                                }

                                production.moneyUsedComputed = production.moneyUsed;
                                production.suppliesUsedComputed = production.suppliesUsed;

                                if( self.isUseCollectionsPerDay ) {
                                    let multiplier = elvenStats.getFrequencyMultiplierForUser(m,false);
                                    production.suppliesComputed *= multiplier;
                                    production.suppliesUsedComputed *= multiplier;
                                    production.moneyUsedComputed *= multiplier;
                                }

                                production.moneyComputed += production.moneyBonus;
                                production.suppliesComputed += production.suppliesBonus;

                                production.moneyRemainingComputed = production.moneyComputed - production.moneyUsed;
                                production.suppliesRemainingComputed = production.suppliesComputed - production.suppliesUsed;

                                return m;
                            } else {
                                console.error("Member " + member.username + " can't be calculated, no city report for user");
                                return null;
                            }
                        }catch(err) {
                            console.error("Error computing money/culture table", err);
                        }
                    });

                    computed = _.compact(computed);

                    return computed;
                }
            },
            headers: {
                get: function() {
                    let isSortable = this.members && this.members.length > 1;
                    let headers = [];

                    if( this.members && this.members.length > 1 ) {
                        headers.push({text: "", value: 'avatar', sortable: false});
                        headers.push({text: this.$i18n.t('site.common.username'), align: 'left', sortable: isSortable, value: 'username'});
                    }
                    headers.push({class: 'minBoostPercentTh', icon: "culture_boost", subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.minBoostPercent'), value: 'cityReport.cultureBoostPercent',sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.minimumCultureBoostPercent')});
                    headers.push({icon: "coins", subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.made'), value: 'cityReport.production.moneyComputed', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.moneyComputedTip')});
                    headers.push({icon: 'coins', subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.used'), value: 'cityReport.production.moneyUsedComputed', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.moneyUsedComputedTip')});
                    headers.push({icon: 'coins', subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.left'), value: 'cityReport.production.moneyRemainingComputed', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.moneyRemainingComputedTip')});
                    headers.push({icon: 'supplies', subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.made'), value: 'cityReport.production.suppliesComputed', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.suppliesComputedTip')});
                    headers.push({icon: 'supplies', subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.used'), value: 'cityReport.production.suppliesUsedComputed', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.suppliesUsedComputedTip')});
                    headers.push({icon: 'supplies', subtitle: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.left'), value: 'cityReport.production.suppliesRemainingComputed', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.suppliesRemainingComputedTip')});
                    headers.push({icon:"mana", subtitle: ' ', value: 'cityReport.production.mana', sortable: isSortable, tooltip: this.$i18n.t('site.fellowship.coinsAndSuppliesTable.manaTip')});
                    return headers;
                }
            }
        }
    }
</script>

<style scoped>


    .otherProductionToggleArea {
        margin-left: 40px;
        margin-top: 10px;
        margin-bottom: -15px;
    }

    .header-icon-caption {
        position:relative;
        top:24px;
        font-size: 95%;
        padding: 0px 2px 0px 2px;
        text-align: center;
        width: 28px;
    }
    .header-icon-container {
        background-repeat: no-repeat;
        background-position-y: top;
        background-position-x: center;
        position:relative;
        top:-4px;
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 5px;
        width:32px;
        min-width:32px;
        height:24px;
        display: inline-block;
    }

    input[type="tel"] {
        margin: 0;
        padding: 0;
        width: 65px;
    }

    th .tooltip {
        position: unset;
        font-family: unset;
        font-size: unset;
        font-style: unset;
        font-weight: unset;
        line-height: unset;
        text-align: unset;
        text-align: left;
        display: unset;
        /* text-decoration:none; */
        /* text-shadow:none; */
        text-transform: uppercase;
        letter-spacing: unset;
        word-break: unset;
        word-spacing: unset;
        word-wrap: unset;
        white-space: unset;
        filter: unset;
        line-break: unset;
        opacity: unset;
        /* line-break:auto; */
    }

    table.table tfoot tr td {
        padding: 0 24px
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvOtherProductionTable.vue